import React, { useState, useEffect, useRef } from "react";
import apiService from "../config";
import { useLanguage } from '../StoreContext/LanguageContext';
import { X } from "lucide-react";

const SubSection3A = ({ fetchButtonStatus }) => {
  const [isEditing, setIsEditing] = useState(false);
  const { language, translations } = useLanguage();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [showSendToProjectInchargeModal, setShowSendToProjectInchargeModal] = useState(false);
  const [usersProjectIncharge, setUsersProjectIncharge] = useState([]);
  const [loadingUsersProjectIncharge, setLoadingUsersProjectIncharge] = useState(false);
  const [selectedUserProjectIncharge, setSelectedUserProjectIncharge] = useState('');
  const [remarksProjectIncharge, setRemarksProjectIncharge] = useState('');
  const [selectedDocumentProjectIncharge, setSelectedDocumentProjectIncharge] = useState(null);
  const [sendingToProjectIncharge, setSendingToProjectIncharge] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);

    // Project Id
    useEffect(() => {
      const getProjectInfo = () => {
        const selectedProject = localStorage.getItem('selectedProject');
        if (selectedProject) {
          try {
            const project = JSON.parse(selectedProject);
            return {
              id: project.project_id || project.id,
              name: project.project_name || project.name
            };
          } catch (e) {
            console.error('Error parsing selected project (selectedProject):', e);
          }
        }

        const userData = localStorage.getItem('userData');
        if (userData) {
          try {
            const user = JSON.parse(userData);
            const projectId = user.data?.project_id || user.project_id;
            const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
            return {
              id: projectId,
              name: projectName
            };
          } catch (e) {
            console.error('Error parsing user data (userData):', e);
          }
        }
        return { id: null, name: null };
      };

      const projectInfo = getProjectInfo();
      setProjectId(projectInfo.id);
      console.log('Current Project Info:', projectInfo);
    }, []);

    // Proposal id
    useEffect(() => {
      const getProposalInfo = () => {
        const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

        if (currentProposal) {
          try {
            return {
              proposalId: currentProposal?.data?.default_proposal ||
                currentProposal?.data?.proposal_id ||
                currentProposal?.default_proposal ||
                currentProposal?.proposal_id ||
                null
            }
          } catch (e) {
            console.error('Error parsing current project data (getProposalInfo):', e);
          }
        }
        return { proposalId: null };
      };

      const proposalInfo = getProposalInfo();
      setProposalId(proposalInfo.proposalId);
      console.log('Current Project-Proposal Info:', proposalInfo);
    }, []);

  const fetchUsersProjectIncharge = async () => {
    const role = 18; 
    setLoadingUsersProjectIncharge(true);
    try {
      const response = await apiService.getAllUserRoleProjectIncharge(
        role,
        projectId,
        proposalId
      );

      if (response.status === 200 && response.data) {
        setUsersProjectIncharge(Array.isArray(response.data) ? response.data : []);
      } else {
        setUsersProjectIncharge([]);
      }
    } catch (error) {
      console.error('Error fetching Project Incharge users:', error);
      setUsersProjectIncharge([]);
    } finally {
      setLoadingUsersProjectIncharge(false);
    }
  };

  useEffect(() => {
    if (showSendToProjectInchargeModal) {
      fetchUsersProjectIncharge();
    }
  }, [showSendToProjectInchargeModal]);

  const handleSendToProjectIncharge = async () => {
    if (!selectedUserProjectIncharge || !selectedDocumentProjectIncharge) {
      alert('Please select user and upload document');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required');
      return;
    }

    setSendingToProjectIncharge(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksProjectIncharge);
      formData.append('usr_id', selectedUserProjectIncharge);
      formData.append('document', selectedDocumentProjectIncharge);

      const response = await apiService.postTrackingSendToProjectIncharge(formData);

      if (response.status === 200) {
        alert('Successfully sent to Project Incharge');
        setShowSendToProjectInchargeModal(false);
        setSelectedUserProjectIncharge('');
        setRemarksProjectIncharge('');
        setSelectedDocumentProjectIncharge(null);
        fetchButtonStatus();
      } else {
        alert('Failed to send to Project Incharge');
      }
    } catch (error) {
      console.error(error);
      alert('Failed to send to Project Incharge');
    } finally {
      setSendingToProjectIncharge(false);
    }
  };

  // Add this inside Section3A component, before the return statement
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
    @media print {
      body * {
        visibility: hidden;
      }
      .print-container,
      .print-container * {
        visibility: visible;
      }
      .print-container {
        position: absolute;
        left: 0;
        top: 0;
      }
      .print:hidden {
        display: none !important;
      }
      @page {
        size: A4;
        margin: 0;
      }
    }
  `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const handlePrintView = () => {
    window.print();
  };

  const handleSubmit = () => {
  };

  const renderEditModal = () => (
    <div className="min-h-screen bg-gray-400 py-8 flex flex-col items-center gap-8">
      <div className="fixed top-6 right-6 flex gap-4 print:hidden z-50">

        {/* HEADER (same as your design) */}
        {/* <div className="flex justify-between items-center px-6 py-4 border-b"> */}
        <h2 className="text-2xl font-bold text-gray-800">
          Section 3A – Edit
        </h2>
        <button
          onClick={() => setIsEditing(false)}
          className="text-2xl font-bold text-gray-500"
        >
          ×
        </button>
        {/* </div> */}

        {/* BODY */}
        <div className="p-6 bg-gray-100">
          <Section3AEditable />
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-4 px-6 py-4 border-t">
          <button
            onClick={() => setIsEditing(false)}
            className="px-6 py-2 border rounded-lg"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-8 py-2 bg-blue-600 text-white rounded-lg"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );

  const Section3AEditModal = ({ onClose }) => {
    return (
      <div className="fixed inset-0 z-50 bg-black/40 flex justify-center items-center p-4">
        <div className="bg-white w-full max-w-5xl rounded-2xl shadow-xl overflow-hidden">

          {/* HEADER */}
          <div className="flex justify-between items-center px-6 py-4 border-b">
            <h2 className="text-2xl font-bold text-gray-800">
              Section 3A
            </h2>
            <button onClick={onClose}>
              <X size={24} />
            </button>
          </div>

          {/* BADGE */}
          <div className="flex justify-center mt-4">
            <span className="px-6 py-2 bg-blue-600 text-white rounded-full font-semibold">
              भूमिसंपादन प्रकरण तपशील
            </span>
          </div>

          {/* FORM */}
          <div className="p-6 grid grid-cols-1 md:grid-cols-4 gap-4">

            <Input label="दिनांक" type="date" />
            <Input label="Highway No." placeholder="Enter Highway No" />
            <Input label="District" placeholder="Enter District" />
            <Input label="State" placeholder="Enter State" />

            <Input label="Km From" placeholder="Km Start" />
            <Input label="Km To" placeholder="Km End" />
            <Input label="Section Name" placeholder="Enter Section Name" />
            <Input label="Notification No." placeholder="Enter Notification No" />
          </div>

          {/* PART ONE */}
          <div className="flex justify-center my-4">
            <span className="px-6 py-2 bg-blue-600 text-white rounded-full font-semibold">
              भाग - एक
            </span>
          </div>

          {/* PARAGRAPH */}
          <div className="px-6">
            <label className="block font-semibold mb-1">तपशील:</label>
            <textarea
              rows={6}
              className="w-full border rounded-lg p-3"
              placeholder="Enter notification details..."
            />
          </div>

          {/* TABLE */}
          <div className="px-6 mt-6 overflow-x-auto">
            <table className="w-full border text-sm">
              <thead className="bg-gray-100">
                <tr>
                  {[
                    "Sr",
                    "District",
                    "Taluka",
                    "Village",
                    "Survey No",
                    "Type",
                    "Nature",
                    "Area",
                    "Total Area",
                  ].map(h => (
                    <th key={h} className="border px-2 py-2">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[1, 2].map(i => (
                  <tr key={i}>
                    {Array(9).fill("").map((_, j) => (
                      <td key={j} className="border p-1">
                        <input
                          className="w-full outline-none"
                          placeholder="—"
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* FOOTER */}
          <div className="flex justify-end gap-4 px-6 py-4 border-t mt-6">
            <button
              onClick={onClose}
              className="px-6 py-2 border rounded-lg"
            >
              Cancel
            </button>
            <button className="px-8 py-2 bg-blue-600 text-white rounded-lg">
              Save
            </button>
          </div>
        </div>
      </div>
    );
  };

  const Section3AEditable = () => {
    return (
      <div className="bg-white w-[794px] min-h-[1123px] mx-auto p-[60px] font-serif text-[14px] leading-[1.8]">

        <p className="text-center uppercase font-semibold">
          [To be published in the Gazette of India, Extraordinary Part-II,
          Section 3, Sub-section (ii)]
        </p>

        <p className="text-center font-bold mt-6">GOVERNMENT OF INDIA</p>
        <p className="text-center font-semibold">
          MINISTRY OF SHIPPING, ROAD TRANSPORT AND HIGHWAYS
        </p>

        <p className="text-center font-bold mt-8">NOTIFICATION</p>

        {/* DATE */}
        <p className="text-right mt-4">
          NEW DELHI, Dated the{" "}
          <span
            contentEditable
            className="border-b-2 border-green-600 px-2 outline-none"
          >
            _________
          </span>{" "}
          2024
        </p>

        {/* MAIN PARA */}
        <p className="mt-8 text-justify indent-8">
          S.O. (E).- In exercise of powers conferred by sub-section (1) of
          section 3A of the National Highways Act, 1956, for the purpose of
          building National Highway No.
          <span contentEditable className="border-b-2 border-green-600 px-2 mx-1">
            _________
          </span>
          in the district of
          <span contentEditable className="border-b-2 border-green-600 px-2 mx-1">
            __________
          </span>
          State of
          <span contentEditable className="border-b-2 border-green-600 px-2 mx-1">
            __________
          </span>
          hereby declares its intention to acquire such land.
        </p>

        {/* TABLE */}
        <table className="w-full border border-black mt-6 text-[12px]">
          <thead>
            <tr>
              {["Sr", "District", "Taluka", "Village", "Survey", "Type", "Nature", "Area", "Total"].map(h => (
                <th key={h} className="border px-1 py-1">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[1, 2].map(i => (
              <tr key={i}>
                {Array(9).fill("").map((_, j) => (
                  <td
                    key={j}
                    contentEditable
                    className="border px-1 py-1 text-center border-green-600 outline-none"
                  >
                    &nbsp;
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const Input = ({ label, type = "text", placeholder }) => {
    return (
      <div>
        <label className="block font-semibold mb-1">{label}</label>
        <input
          type={type}
          placeholder={placeholder}
          className="w-full border rounded-lg px-3 py-2"
        />
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-400 py-8 flex flex-col items-center gap-8">

      {isEditOpen && (
        <Section3AEditModal onClose={() => setIsEditOpen(false)} />
      )}

      {/* ========== ENGLISH PAGE 1 ========== */}
      <div className="print-container">
        {/* TOP RIGHT ACTIONS - Fixed position */}
        <div className="flex justify-end gap-4 mb-4 print:hidden">
          {/* print */}
          <button
            type="button"
            onClick={handlePrintView}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            {translations[language]?.Print}
          </button>
          {/* Edit Button */}
          <button
            onClick={() => setIsEditOpen(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            {translations[language]?.edit}
          </button>

          {/* Send to Project Incharge Button */}
          <button
            onClick={() => setShowSendToProjectInchargeModal(true)}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
          >
            {translations[language]?.SendToProjectIncharge}
          </button>
        </div>

        <div className="bg-white w-[794px] min-h-[1123px] p-[60px] font-serif text-black text-[14px] leading-[1.8] shadow-lg">
          <p className="text-center uppercase font-semibold">
            [To be published in the Gazette of India, Extraordinary Part-II,
            Section 3, Sub-section (ii)]
          </p>

          <p className="text-center font-bold mt-6">GOVERNMENT OF INDIA</p>
          <p className="text-center font-semibold">
            MINISTRY OF SHIPPING, ROAD TRANSPORT AND HIGHWAYS
          </p>
          <p className="text-center text-sm">
            (Department of Road Transport and Highways)
          </p>

          <p className="text-center font-bold mt-8">NOTIFICATION</p>

          <p className="text-right mt-4">
            NEW DELHI, Dated the _________ 2024
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            S.O. (E).- In exercise of powers conferred by sub-section (1) of
            section 3A of the National Highways Act, 1956 (48 of 1956)
            (hereinafter referred to as the said Act), the Central Government,
            after being satisfied that for the public purpose, the land, the
            brief description of which is given in the Schedule below, is
            required for building (widening / four-laning, etc.), maintenance,
            management and operation of National Highway No. 753A, in the
            stretch of land from Km. 68/900 to Km. 108/500 (Chikhli—Takarkhed
            Bhagile Section) in the district of Buldhana in the State of
            Maharashtra, hereby declares its intention to acquire such land;
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            Any person interested in the said land may, within twenty-one days
            from the date of publication of this notification in the Official
            Gazette, object to the use of such land for the aforesaid purpose
            under sub-section (1) of section 3C of the said Act.
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            Every such objection shall be made to the competent authority,
            namely, the Sub-Divisional Officer Buldhana, in writing and shall
            set out the grounds thereof and the competent authority shall give
            the objector an opportunity of being heard, either in person or by
            a legal practitioner, and may, after hearing such objections and
            after making such further inquiry, if any, as the competent
            authority thinks necessary, by order, either allow or disallow the
            objections.
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            Any order made by the competent authority under sub-section (2) of
            section 3C of the said Act shall be final.
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            The land plans and other details of the land covered under this
            notification are available and can be inspected by the interested
            person at the aforesaid office of the competent authority.
          </p>
        </div>

        {/* ========== ENGLISH PAGE 2 - SCHEDULE ========== */}
        <div className="bg-white w-[794px] min-h-[1123px] p-[60px] font-serif text-black text-[14px] leading-[1.8] shadow-lg">
          <p className="text-center font-bold">SCHEDULE</p>

          <p className="mt-4 text-justify">
            Brief description of the land to be acquired with or without
            structure falling within the stretch of land from Km. 68/900 to
            Km. 108/500 (Chikhli—Takarkhed Bhagile Section) of the National
            Highway No. 753A in the State of Maharashtra.
          </p>

          <table className="w-full border border-black mt-6 text-[12px]">
            <thead>
              <tr>
                {[
                  "Serial No.",
                  "Name of District",
                  "Name of Taluka",
                  "Name of Village",
                  "Survey No.",
                  "Type",
                  "Nature",
                  "Area to be acquired (Hect.)",
                  "Total Area (Hect.)"
                ].map(h => (
                  <th key={h} className="border border-black px-1 py-1 text-center">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border text-center">1</td>
                <td className="border text-center">Buldhana</td>
                <td className="border text-center">Chikhli</td>
                <td className="border text-center">Muradpur</td>
                <td className="border text-center">72</td>
                <td className="border text-center">Private</td>
                <td className="border text-center">Agricultural</td>
                <td className="border text-center">0.12</td>
                <td className="border text-center">5.29</td>
              </tr>
              <tr>
                <td className="border text-center">2</td>
                <td className="border text-center">Buldhana</td>
                <td className="border text-center">Chikhli</td>
                <td className="border text-center">Muradpur</td>
                <td className="border text-center">74</td>
                <td className="border text-center">Private</td>
                <td className="border text-center">Agricultural</td>
                <td className="border text-center">0.05</td>
                <td className="border text-center">5.16</td>
              </tr>
            </tbody>
          </table>

          <div className="flex justify-between mt-12 text-sm">
            <div>
              <p>Competent Authority</p>
              <p>Sub-Divisional Officer</p>
              <p>Buldhana</p>
            </div>

            <div className="text-right">
              <p>Executive Engineer</p>
              <p>National Highway Division,</p>
              <p>Akola</p>
            </div>
          </div>

          <p className="text-right mt-10 text-sm">
            [F No. ____________]
          </p>
          <p className="text-right mt-10 text-sm">
            (____________)
          </p>
          <p className="text-right mt-6 text-sm">
            Deputy Secretary to the Government of India
          </p>
        </div>

        {/* ========== HINDI PAGE 1 ========== */}
        <div className="bg-white w-[794px] min-h-[1123px] p-[60px] font-serif text-black text-[14px] leading-[1.8] shadow-lg">
          <p className="text-center font-semibold">
            [भारत के राजपत्र, असाधारण, भाग 3, खण्ड 3, उपखण्ड (iii) में प्रकाशनार्थ]
          </p>

          <p className="text-center font-bold mt-6">भारत सरकार</p>
          <p className="text-center font-semibold">
            पोत परिवहन, सड़क और राजमार्ग मंत्रालय
          </p>
          <p className="text-center text-sm">
            (सड़क परिवहन और राजमार्ग विभाग)
          </p>

          <p className="text-center font-bold mt-8">अधिसूचना</p>

          <p className="text-right mt-4">
            नई दिल्ली, तारीख: _________ 2024
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            का.आ.अ.सं(अ)राष्ट्रीय महामार्गएक्स्प्रे-१९५२/......../२०१८ (भ)- केंद्रीय सरकार,
            राष्ट्रीय राजमार्ग अधिनियम, १९५६ (१९५६ का ८४) (इसमें इसके पश्चात् कथित अधिनियम कहा
            जाएगा) की धारा ३ क (१) की उपधारा (१) द्वारा प्रदत्त शक्तियों का प्रयोग करते हुए, इस
            बात से संतुष्ट होने के पश्चात् कि लोक प्रयोजन के लिए जिस भूमि का संक्षिप्त विवरण
            नीचे दी गई अनुसूची में दिया गया है उस राष्ट्रीय राजमार्ग संख्या ७५३ ए के ६८/९०० कि.मी. से १०८/५००
            कि.मी. (चिखली- टाकरखेड भागीले भाग) तक के भूखंड के (विस्तारण, चार/छह लेन, आदि)
            निर्माण, रखरखाव, प्रबंधन और प्रचालन के लिए यह भूमि अपेक्षित है
            जिसको अर्जित करने के लिए अपना अभिप्राय घोषित करती है।
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            कोई भी व्यक्ति, जो उक्त भूमि में हितबद्ध है, उक्त अधिनियम की धारा ३ ग की उपधारा (१)
            के अधीन पूर्वोक्त प्रयोजन के लिए ऐसी भूमि के उपयोग पर इस अधिसूचना की
            सरकारी राजपत्र में प्रकाशन की तारीख से इक्कीस दिन के भीतर आक्षेप कर सकेगा।
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            ऐसी आपत्ति सक्षम प्राधिकारी को लिखित रूप में की जाएगी और उसमें उसके आधार अभिकथित किए जाएंगे और सक्षम
            प्राधिकारी, आक्षेपकर्ता को व्यक्तिगत रूप से या किसी विधिक व्यवसायी द्वारा सुने जाने का
            अवसर देंगे तथा ऐसे आक्षेप को सुनने के पश्चात तथा ऐसी और जांच करने के पश्चात, यदि कोई हो, जिसे सक्षम
            प्राधिकारी आवश्यक समझे, आदेश द्वारा या तो आक्षेप को अनुज्ञात कर सकेगा या अननुज्ञात कर सकेगा।
          </p>

          <p className="mt-8 text-justify leading-loose indent-8">
            उक्त अधिनियम की धारा ३ ग की उपधारा (२) के अधीन सक्षम प्राधिकारी द्वारा किया गया कोई आदेश अंतिम होगा और
          </p>
          <p className="mt-8 text-justify leading-loose indent-8">
            इस अधिसूचना के अंतर्गत आने वाली भूमि के रेखांक और अन्य ब्यौरे सक्षम प्राधिकारी के उक्त कार्यालय में उपलब्ध है और उनका हितबध्द व्यक्ति द्वारा निरीक्षण किया जा सकता है        </p>
        </div>

        {/* ========== HINDI PAGE 2 - SCHEDULE ========== */}
        <div className="bg-white w-[794px] min-h-[1123px] p-[60px] font-serif text-black text-[14px] leading-[1.8] shadow-lg">
          <p className="text-center font-bold">अनुसूची</p>

          <p className="mt-4 text-justify">
            महाराष्ट्र राज्य के बुलढाणा जिले में राष्ट्रीय राजमार्ग संख्या ७५३ ए के
            कि.मी. ६८/९०० से कि.मी. १०८/५०० तक अर्जित की जाने वाली भूमि का विवरण
          </p>

          <table className="w-full border border-black mt-6 text-[12px]">
            <thead>
              <tr>
                {[
                  "अ.क्र.",
                  "जिला",
                  "तालुका",
                  "गांव",
                  "सर्वे नं.",
                  "भूमि का प्रकार",
                  "भूमि की प्रकृति",
                  "अर्जित क्षेत्र (हे.)",
                  "कुल क्षेत्र (हे.)"
                ].map(h => (
                  <th key={h} className="border border-black px-1 py-1 text-center">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border text-center">१</td>
                <td className="border text-center">बुलढाणा</td>
                <td className="border text-center">चिखली</td>
                <td className="border text-center">मुराडपूर</td>
                <td className="border text-center">७२</td>
                <td className="border text-center">खाजगी</td>
                <td className="border text-center">कृषी</td>
                <td className="border text-center">०.१२</td>
                <td className="border text-center">५.२९</td>
              </tr>
              <tr>
                <td className="border text-center">२</td>
                <td className="border text-center">बुलढाणा</td>
                <td className="border text-center">चिखली</td>
                <td className="border text-center">मुराडपूर</td>
                <td className="border text-center">७४</td>
                <td className="border text-center">खाजगी</td>
                <td className="border text-center">कृषी</td>
                <td className="border text-center">०.०५</td>
                <td className="border text-center">५.१६</td>
              </tr>
            </tbody>
          </table>

          <div className="flex justify-between mt-12 text-sm">
            <div>
              <p>सक्षम प्राधिकारी</p>
              <p>उप-विभागीय अधिकारी</p>
              <p>बुलढाणा</p>
            </div>

            <div className="text-right">
              <p>(अधिशासी अभियंता)</p>
              <p>राष्ट्रीय राजमार्ग विभाग</p>
              <p>अकोला</p>
            </div>
          </div>
        </div>
      </div>

      {showSendToProjectInchargeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4">
            <div className="p-6 space-y-4">

              <label className="text-sm font-medium">
                Select Project Incharge *
              </label>

              <select
                value={selectedUserProjectIncharge}
                onChange={(e) => setSelectedUserProjectIncharge(e.target.value)}
                disabled={loadingUsersProjectIncharge}
                className="w-full p-3 border rounded-lg"
              >
                <option value="">Select User</option>
                {usersProjectIncharge.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.full_name}
                  </option>
                ))}
              </select>

              <textarea
                value={remarksProjectIncharge}
                onChange={(e) => setRemarksProjectIncharge(e.target.value)}
                rows={3}
                placeholder="Enter remarks"
                className="w-full p-3 border rounded-lg"
              />

              <input
                type="file"
                onChange={(e) => setSelectedDocumentProjectIncharge(e.target.files[0])}
                className="w-full p-3 border rounded-lg"
              />

              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  onClick={() => setShowSendToProjectInchargeModal(false)}
                  className="px-4 py-2 border rounded-lg"
                >
                  Cancel
                </button>

                <button
                  onClick={handleSendToProjectIncharge}
                  disabled={sendingToProjectIncharge}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg"
                >
                  {sendingToProjectIncharge ? 'Sending...' : 'Send'}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default SubSection3A;
